import React, { useState } from "react";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";

const DeletePopup = ({
  isOpen,
  onClose,
  tableName,
  tableId,
  isActive,
  fetchTabledata,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleToggleStatus = async () => {
    setIsSubmitting(true);
    try {
      const response = await apiService.put(`tables/${tableId}`, {
        is_active: !isActive,
      });
      if (response.status === 200) {
        onClose(); // Close modal after 2 seconds
        toast.success(
          `Table ${tableName} has been ${!isActive ? "activated" : "deactivated"
          }.`,
          { duration: 2000 }
        );
        fetchTabledata();
      }
    } catch (errors) {
      handleError(errors);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
        <div className="bg-white rounded-lg p-6 w-[310px] sm:w-[350px] h-auto shadow-lg relative">
          <p className="text-lg font-semibold text-center mb-8">
            Are you sure you want to {isActive ? "deactivate" : "activate"}
            <span className="text-lg font-bold"> {tableName} </span>?
          </p>
          <div className="flex justify-center gap-4 mt-4">
            <button
              className="w-[75px] sm:w-[93px] text-sm py-2 text-center border border-green text-green rounded-lg"
              onClick={onClose}
            >
              Close
            </button>
            <button
              onClick={() => {
                handleToggleStatus();
              }}
              className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${isSubmitting
                ? "bg-green50 cursor-not-allowed"
                : "bg-green text-white"
                }`}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Confirming..." : "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeletePopup;
